<template>
  <div class="sa-ann">
    <h1 class="sa-ann__title">📢 平台公告</h1>
    <p class="sa-ann__subtitle">來自平台的最新公告與說明</p>

    <div v-if="loading" class="sa-ann__state">載入中…</div>
    <div v-else-if="announcements.length === 0" class="sa-ann__state">目前沒有公告</div>

    <div v-else class="sa-ann__list">
      <div
        v-for="a in visibleList"
        :key="a.id"
        class="sa-ann__item"
        @click="goDetail(a.id)"
      >
        <span class="sa-ann__badge">公告</span>
        <span class="sa-ann__name">{{ a.title }}</span>
        <span class="sa-ann__date">{{ formatDate(a.created_at) }}</span>
        <span class="sa-ann__arrow">→</span>
      </div>
      <!-- 更多公告按鈕 -->
      <div v-if="hasMore && !showAll" class="sa-ann__more" @click="showAll = true">
        更多公告 ↓
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()
const announcements = ref([])
const loading = ref(false)
const showAll = ref(false)

const PAGE_SIZE = 5
const visibleList = computed(() =>
  showAll.value ? announcements.value : announcements.value.slice(0, PAGE_SIZE)
)
const hasMore = computed(() => announcements.value.length > PAGE_SIZE)

function goDetail(id) {
  router.push({ name: 'StoreAdminAnnouncementDetail', params: { id } })
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric', month: '2-digit', day: '2-digit'
  })
}

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/api/booking/announcements/active')
    announcements.value = data.announcements || []
  } catch (_) { /* 靜默忽略 */ } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.sa-ann { max-width: 760px; margin: 0 auto; }
.sa-ann__title    { font-size: 1.6rem; font-weight: 700; color: #2c3e50; margin-bottom: 6px; }
.sa-ann__subtitle { color: #7f8c8d; font-size: 0.95rem; margin-bottom: 28px; }
.sa-ann__state    { color: #aaa; font-size: 0.95rem; padding: 32px 0; text-align: center; }

.sa-ann__list {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.sa-ann__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s;
}
.sa-ann__item:last-child { border-bottom: none; }
.sa-ann__item:hover { background: #fafafa; }

.sa-ann__badge {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  background: #f59e0b;
  color: #fff;
  letter-spacing: 0.03em;
}

.sa-ann__name {
  flex: 1;
  font-size: 0.93rem;
  font-weight: 600;
  color: #2c3e50;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sa-ann__date {
  flex-shrink: 0;
  font-size: 0.8rem;
  color: #aaa;
}

.sa-ann__arrow {
  flex-shrink: 0;
  font-size: 0.8rem;
  color: #bbb;
}

.sa-ann__more {
  padding: 13px 18px;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  transition: background 0.15s;
  border-top: 1px solid #f0f0f0;
}
.sa-ann__more:hover { background: #f8f9fa; }
</style>
